export interface IGoodsItem {
  name: string;
  key: string;
  giftTypes: string[];
}

export class GoodsByCategory {
  constructor(
    private readonly _event: IGoodsItem[],
    private readonly _photo: IGoodsItem[],
    private readonly _storage: IGoodsItem[],
    private readonly _accessory: IGoodsItem[],
    private readonly _decoration: IGoodsItem[]
  ) {}

  get event(): IGoodsItem[] {
    return [...this._event];
  }

  get photo(): IGoodsItem[] {
    return [...this._photo];
  }

  get storage(): IGoodsItem[] {
    return [...this._storage];
  }

  get accessory(): IGoodsItem[] {
    return [...this._accessory];
  }

  get decoration(): IGoodsItem[] {
    return [...this._decoration];
  }

  public getAllGoods(): IGoodsItem[] {
    return [
      ...this._event,
      ...this._photo,
      ...this._storage,
      ...this._accessory,
      ...this._decoration
    ];
  }

  public getGoodsByCategory(category: string): IGoodsItem[] {
    switch (category.toLowerCase()) {
      case 'event':
        return this.event;
      case 'photo':
        return this.photo;
      case 'storage':
        return this.storage;
      case 'accessory':
        return this.accessory;
      case 'decoration':
        return this.decoration;
      default:
        return [];
    }
  }
}
